import withFormikWrapper from '../formik/withFormikWrapper';
import StateSelect from '../stateSelect/stateSelect';

export const CleanFormikStateSelect = withFormikWrapper({ onChangeProp: 'onChange' })(StateSelect);
